import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconDoubleTick: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#b0b0b0',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 -960 960 960"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z"
      fill={color}
    />
  </svg>
);

export default IconDoubleTick;
